/*
 * Copyright 2025 coze-dev Authors
 * Modifications Copyright 2026 Bytefinger Technology (HK) Co., Limited (https://bytefinger.ai).
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { useShallow } from 'zustand/react/shallow';
import { Layout } from '@adp-common/chat-uikit-shared';

import { useChatAreaStoreSet } from '../context/use-chat-area-context';
import { type Message, type UserSenderInfo } from '../../store/types';
import { usePreference } from '../../context/preference';

export const useDisplayUserInfo = (message: Message) => {
  const { layout, showUserExtendedInfo } = usePreference();
  const { useSenderInfoStore } = useChatAreaStoreSet();

  const getMessageUserInfo = useSenderInfoStore(
    useShallow(state => state.getMessageUserInfo),
  );

  const userSenderInfo = getMessageUserInfo(message?.sender_id);

  if (!userSenderInfo) {
    return null;
  }

  const infoWithoutExtend: UserSenderInfo = {
    ...userSenderInfo,
    userLabel: null,
    userUniqueName: '',
  };

  if (layout !== Layout.PC || !showUserExtendedInfo) {
    return infoWithoutExtend;
  }

  return userSenderInfo;
};
